export const extractProductNameFromUrl = (tptUrl) => {
    if (!tptUrl || typeof tptUrl !== 'string') return null;
    try {
        const url = new URL(tptUrl);
        if (url.hostname.includes('teacherspayteachers.com')) {
            const pathParts = url.pathname.split('/');
            const productIndex = pathParts.indexOf('Product');
            if (productIndex !== -1 && pathParts.length > productIndex + 1) {
                let nameWithId = pathParts[productIndex + 1];
                const lastHyphenIndex = nameWithId.lastIndexOf('-');
                if (lastHyphenIndex !== -1 && /^\d+$/.test(nameWithId.substring(lastHyphenIndex + 1))) {
                    nameWithId = nameWithId.substring(0, lastHyphenIndex);
                }
                return nameWithId.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            }
        }
    } catch (parseError) {
        console.warn("Could not parse URL for product name:", tptUrl, parseError);
        return null;
    }
    return null;
};

export const extractProductIdFromTptUrl = (tptUrl) => {
    if (!tptUrl || typeof tptUrl !== 'string') return null;
    try {
        const url = new URL(tptUrl);
        const pathParts = url.pathname.split('/');
        let idPart = null;
        const productIndex = pathParts.indexOf('Product');
        if (productIndex !== -1 && pathParts.length > productIndex + 1) {
            const slugWithId = pathParts[productIndex + 1];
            const lastHyphenIndex = slugWithId.lastIndexOf('-');
            if (lastHyphenIndex !== -1) {
                const potentialId = slugWithId.substring(lastHyphenIndex + 1);
                if (/^\d+$/.test(potentialId)) {
                    idPart = potentialId;
                }
            } else if (/^\d+$/.test(slugWithId)) {
                idPart = slugWithId;
            }
        }
        if (!idPart) {
            const itemsIndex = pathParts.findIndex(part => part === 'items' || part === 'itemsBundle' || part === 'itemsDigital');
            if (itemsIndex !== -1 && pathParts.length > itemsIndex + 1) {
                const potentialId = pathParts[itemsIndex + (pathParts[itemsIndex + 1] === 'editNext' ? 2 : 1)];
                if (/^\d+$/.test(potentialId)) {
                    idPart = potentialId;
                }
            }
        }
        return idPart;
    } catch (e) {
        console.error("Error extracting product ID from TPT URL:", tptUrl, e);
        return null;
    }
};

// --- NEW HELPER FOR DUPLICATE PREVENTION ---
export function extractIdFromUrl(url) {
  if (!url) return null;
  try {
    // 1. Remove query parameters
    const cleanUrl = url.split('?')[0];

    // 2. Look for the standard TPT pattern: /Product/Title-Here-12345
    const match = cleanUrl.match(/\/Product\/(?:.*-)?(\d+)\/?$/i);
    if (match && match[1]) {
      return match[1];
    }

    // 3. Fallback: Check strictly for digits at the end of the string
    const lastPart = cleanUrl.split('-').pop();
    if (/^\d+$/.test(lastPart)) {
        return lastPart;
    }

    return null;
  } catch (e) {
    return null;
  }
}